import { JSONObject } from '../../types/types';

// Plain (non-array, non-null) JSON object. Meant for values coming from
// JSON.parse, which are JSON-safe by construction.
export const isPlainJsonObject = (value: unknown): value is JSONObject =>
  !!value && typeof value === 'object' && !Array.isArray(value);
